/* eslint-disable max-len */
import { useTheme } from '@mui/material';

export const AlreadyRented = () => {
  const { palette } = useTheme();

  return (
    <svg
      width="121"
      height="120"
      viewBox="0 0 121 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.413 7.88049C7.80435 8.69193 5.00715 13.2281 5.8186 19.8368L16.5702 107.402C17.3817 114.011 21.1932 117.735 27.8019 116.924L65.8019 112.258C72.4106 111.447 75.2078 106.91 74.3963 100.302L63.6447 12.7366C62.8332 6.12794 59.0217 2.40323 52.413 3.21468L14.413 7.88049Z"
        fill={palette.brand.main}
      />
      <mask
        id="mask0_2870_10537"
        maskUnits="userSpaceOnUse"
        x="13"
        y="14"
        width="49"
        height="49"
      >
        <rect
          x="13.3545"
          y="19.7499"
          width="43.2791"
          height="43.2791"
          transform="rotate(-7 13.3545 19.7499)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_2870_10537)">
        <path
          d="M33.283 21.6634L22.5606 40.3681L32.0416 39.204L24.5452 57.6195L43.4265 33.5126L34.788 34.5733L42.685 20.509L33.283 21.6634Z"
          fill="white"
        />
        <path
          d="M44.7334 27.2409L48.7616 19.7629L43.7861 20.3738L39.5719 27.8633L44.7334 27.2409Z"
          fill="white"
        />
        <path
          d="M49.0583 26.71L52.9095 19.2537L49.8335 19.6314L45.797 27.099L49.0583 26.71Z"
          fill="white"
        />
      </g>
      <path
        d="M57.177 75.5831C57.595 75.5318 57.9757 75.8291 58.027 76.2471L58.6441 81.2729L50.3829 82.2872L49.7658 77.2615C49.7145 76.8435 50.0119 76.4628 50.4299 76.4115L57.177 75.5831ZM51.1145 78.005L51.4188 80.4834L52.2456 80.3819L51.9413 77.9035L51.1145 78.005ZM52.7662 77.8022L53.0705 80.2806L53.8963 80.1792L53.592 77.7008L52.7662 77.8022ZM54.4198 77.5992L54.7241 80.0776L55.5499 79.9762L55.2456 77.4978L54.4198 77.5992ZM56.0714 77.3964L56.3757 79.8748L57.2016 79.7734L56.8973 77.295L56.0714 77.3964Z"
        fill={palette.brand.lightest}
      />
      <path
        d="M60.8454 112.867L55.8895 113.476L54.2666 100.258L54.1978 100.267C53.7799 100.318 53.3992 100.021 53.3478 99.6029L53.2378 98.7073L52.3422 98.8172C51.9242 98.8685 51.5436 98.5712 51.4923 98.1532L49.6496 83.1457C49.5983 82.7278 49.8957 82.3471 50.3137 82.2958L58.7125 81.2645C59.1305 81.2132 59.5111 81.5106 59.5625 81.9286L61.4051 96.936C61.4565 97.354 61.1591 97.7346 60.7411 97.786L59.8464 97.8958L59.9564 98.7914C60.0076 99.2093 59.7102 99.5901 59.2923 99.6414L59.2225 99.65L60.8454 112.867Z"
        fill={palette.brand.light}
      />
      <path
        d="M38.8174 83.707L47.0782 82.6927L46.4612 77.667C46.4098 77.249 46.0294 76.9517 45.6114 77.003L38.8642 77.8315C38.4462 77.8828 38.149 78.2633 38.2003 78.6813L38.8174 83.707Z"
        fill={palette.brand.lightest}
      />
      <path
        d="M49.2805 114.286L44.3235 114.895L42.7007 101.678L42.6309 101.686C42.213 101.738 41.8322 101.44 41.7809 101.022L41.671 100.127L40.7763 100.237C40.3584 100.288 39.9779 99.9914 39.9265 99.5736L38.0837 84.5652C38.0324 84.1472 38.3297 83.7665 38.7477 83.7152L47.1466 82.684C47.5646 82.6326 47.9452 82.93 47.9965 83.348L49.8393 98.3564C49.8905 98.7743 49.593 99.1541 49.1752 99.2054L48.2805 99.3153L48.3905 100.211C48.4418 100.629 48.1443 101.009 47.7264 101.061L47.6576 101.069L49.2805 114.286Z"
        fill={palette.brand.light}
      />
      <path
        d="M34.0467 78.4232C34.4645 78.3721 34.8452 78.6695 34.8966 79.0873L35.5137 84.113L27.2525 85.1273L26.6354 80.1016C26.5842 79.6837 26.8816 79.303 27.2995 79.2517L34.0467 78.4232ZM28.398 80.7943L28.7023 83.2728L29.5282 83.1714L29.2239 80.6929L28.398 80.7943ZM32.5281 80.2872L32.8325 82.7657L33.6583 82.6643L33.354 80.1858L32.5281 80.2872Z"
        fill={palette.brand.lightest}
      />
      <path
        d="M37.715 115.708L32.7591 116.316L31.1362 103.099L36.0922 102.49L37.715 115.708ZM35.5821 84.105C36 84.0537 36.3804 84.3503 36.432 84.7681L38.2748 99.7765C38.3261 100.194 38.0287 100.575 37.6107 100.626L36.7151 100.736L36.8249 101.631C36.8762 102.049 36.5796 102.429 36.1618 102.481L31.0663 103.107C30.6483 103.158 30.2677 102.86 30.2164 102.442L30.1065 101.548L29.2119 101.658C28.7939 101.709 28.4132 101.412 28.3619 100.994L26.5191 85.9852C26.4681 85.5674 26.7654 85.1875 27.1833 85.1362L35.5821 84.105Z"
        fill={palette.brand.light}
      />
      <path
        d="M90.5218 31.1198C96.9624 32.508 102.515 35.9383 106.584 40.6215L108.223 39.3822L110.902 42.9213L109.237 44.1806C112.85 49.8701 114.543 56.8167 113.548 64.0103C111.315 80.1524 96.3937 91.425 80.2221 89.1878C64.0499 86.9504 52.7501 72.0505 54.983 55.9083C55.9897 48.6313 59.5751 42.344 64.6905 37.8377L63.5836 36.3753L67.1227 33.6973L68.2304 35.1608C73.3934 31.8321 79.6136 30.0878 86.1258 30.5077L86.3395 28.9628L90.7361 29.5711L90.5218 31.1198Z"
        fill={palette.brand.darkest}
      />
      <path
        d="M109.509 63.4508C107.584 77.3674 94.7218 87.085 80.78 85.1562C66.8381 83.2275 57.0972 70.383 59.0224 56.4664C60.9477 42.5499 73.8098 32.8323 87.7517 34.7611C101.694 36.6898 111.434 49.5343 109.509 63.4508Z"
        fill={palette.brand.lightest}
      />
      <path
        d="M86.7753 41.817C86.2176 41.7399 85.8279 41.2259 85.9049 40.6693L86.1838 38.6533C86.2608 38.0966 86.7754 37.7078 87.3331 37.785C87.8907 37.8621 88.2805 38.3761 88.2035 38.9327L87.9246 40.9487C87.8476 41.5054 87.3329 41.8942 86.7753 41.817Z"
        fill={palette.brand.light}
      />
      <path
        d="M81.1982 82.1322C80.6406 82.0551 80.2507 81.5419 80.3277 80.9852L80.6066 78.9692C80.6836 78.4126 81.1983 78.0237 81.7559 78.1009C82.3136 78.178 82.7033 78.692 82.6263 79.2486L82.3474 81.2646C82.2704 81.8213 81.7559 82.2094 81.1982 82.1322Z"
        fill={palette.brand.light}
      />
      <path
        d="M105.331 63.9002L103.311 63.6208C102.753 63.5437 102.364 63.0297 102.441 62.4731C102.518 61.9165 103.032 61.5276 103.59 61.6048L105.61 61.8842C106.167 61.9613 106.557 62.4753 106.48 63.0319C106.403 63.5886 105.888 63.9774 105.331 63.9002Z"
        fill={palette.brand.light}
      />
      <path
        d="M64.9416 58.3128L62.9219 58.0334C62.3642 57.9563 61.9745 57.4423 62.0515 56.8857C62.1285 56.3291 62.6431 55.9402 63.2008 56.0174L65.2205 56.2968C65.7781 56.3739 66.1679 56.8879 66.0909 57.4445C66.0139 58.0011 65.4992 58.39 64.9416 58.3128Z"
        fill={palette.brand.light}
      />
      <path
        d="M99.5664 49.3022C99.3081 49.2665 99.0634 49.1326 98.8932 48.9082C98.5527 48.4601 98.641 47.8222 99.0904 47.4827L100.715 46.2554C101.164 45.9158 101.803 46.0042 102.143 46.4529C102.483 46.9009 102.394 47.5388 101.946 47.8777L100.321 49.1057C100.097 49.2755 99.8247 49.338 99.5664 49.3022Z"
        fill={palette.brand.light}
      />
      <path
        d="M67.0613 73.8591C66.803 73.8234 66.5583 73.6894 66.3888 73.4651C66.0483 73.017 66.1366 72.3792 66.586 72.0396L68.2105 70.8123C68.6599 70.4728 69.2989 70.5612 69.6386 71.0099C69.9783 71.4579 69.8901 72.0957 69.4414 72.4347L67.8162 73.6626C67.5922 73.8325 67.3196 73.8948 67.0613 73.8591Z"
        fill={palette.brand.light}
      />
      <path
        d="M97.0494 78.0076C96.7911 77.9718 96.5464 77.8379 96.3762 77.6135L95.146 75.9906C94.8056 75.5425 94.8938 74.9046 95.3432 74.5658C95.7919 74.2261 96.4309 74.3146 96.7705 74.7632L98.0015 76.3856C98.3412 76.8343 98.2529 77.4722 97.8043 77.8111C97.5803 77.981 97.3077 78.0433 97.0494 78.0076Z"
        fill={palette.brand.light}
      />
      <path
        d="M72.4337 45.5488C72.1754 45.513 71.9307 45.3791 71.7605 45.1547L70.5303 43.5318C70.1899 43.0837 70.2781 42.4458 70.7274 42.107C71.1754 41.7672 71.8152 41.8557 72.1548 42.3044L73.3858 43.9268C73.7254 44.3755 73.6372 45.0134 73.1886 45.3523C72.9639 45.5221 72.692 45.5845 72.4337 45.5488Z"
        fill={palette.brand.light}
      />
      <path
        d="M84.1977 60.9769C83.9394 60.9411 83.6948 60.8065 83.5245 60.5828L77.3707 52.4683C77.0311 52.0196 77.1193 51.3818 77.568 51.0421C78.0166 50.7039 78.6556 50.7923 78.9961 51.2397L84.5344 58.5434L95.9113 49.9486C96.3599 49.6096 96.9989 49.698 97.3387 50.146C97.6791 50.5941 97.5908 51.2327 97.1415 51.5715L84.9526 60.7804C84.7287 60.9495 84.4567 61.0127 84.1977 60.9769Z"
        fill={palette.brand.darkest}
      />
      <path
        d="M87.2953 60.3778C87.0643 62.0477 85.5212 63.2136 83.8482 62.9821C82.1753 62.7507 81.0059 61.2096 81.2369 59.5397C81.4679 57.8698 83.0119 56.7033 84.6848 56.9347C86.3578 57.1662 87.5263 58.7079 87.2953 60.3778Z"
        fill={palette.brand.light}
      />
      <path
        d="M116.32 43.4579L115.254 44.2647C114.08 45.1536 112.457 44.9765 111.617 43.8673L107.506 38.4361C106.667 37.3275 106.937 35.717 108.111 34.8282L109.177 34.0213C110.352 33.1325 111.975 33.3096 112.814 34.4183L116.925 39.8494C117.765 40.9586 117.494 42.569 116.32 43.4579Z"
        fill={palette.brand.light}
      />
      <path
        d="M94.9473 26.1187L94.7641 27.4429C94.5623 28.9018 93.2891 29.9244 91.9112 29.7338L85.1638 28.8003C83.7865 28.6098 82.8388 27.2799 83.0406 25.8211L83.2238 24.4968C83.4257 23.038 84.6988 22.0154 86.0761 22.2059L92.8234 23.1393C94.2014 23.33 95.1491 24.6598 94.9473 26.1187Z"
        fill={palette.brand.light}
      />
      <path
        d="M58.2222 35.4208L59.0291 36.4867C59.9179 37.6609 61.5284 37.9312 62.6375 37.0916L68.0687 32.9806C69.1773 32.1414 69.3544 30.518 68.4656 29.3438L67.6587 28.2779C66.7699 27.1036 65.1594 26.8334 64.0508 27.6725L58.6197 31.7836C57.5105 32.6232 57.3334 34.2465 58.2222 35.4208Z"
        fill={palette.brand.light}
      />
    </svg>
  );
};
